import { sessionFetch } from '../../../utils/sessionFetch';
import { COLLA, getServerEndpoint } from '../../../utils/utils';
import { API_KEY } from './constants';

function buildUrl(path, query = {}) {
    const queryString = new URLSearchParams(query).toString();
    const baseUrl = `${getServerEndpoint(COLLA)}/api${path}`;
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

async function parseJsonResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
        return null;
    }

    return response.json();
}

async function fetchJson(path, { method = 'GET', body, query } = {}) {
    const response = await sessionFetch(buildUrl(path, query), {
        method,
        headers: {
            'x-api-key': API_KEY,
            ...(body ? { 'Content-Type': 'application/json' } : {}),
        },
        ...(body ? { body: JSON.stringify(body) } : {}),
    });

    const payload = await parseJsonResponse(response);
    if (!response.ok) {
        const error = new Error(payload?.message || 'Error de xarxa');
        error.status = response.status;
        error.payload = payload;
        throw error;
    }

    return payload;
}

export function fetchAletaBillingOverview(userId) {
    return fetchJson('/aleta-billing/overview', {
        query: { userId },
    });
}

export function fetchAletaPaymentReminder(userId) {
    return fetchJson('/aleta-billing/reminder', {
        query: { userId },
    });
}

export function issueAletaInvoice({ userId, periodKey, clientOverrides }) {
    return fetchJson('/aleta-billing/issue', {
        method: 'POST',
        body: {
            userId,
            periodKey,
            clientOverrides,
        },
    });
}

export async function downloadAletaInvoicePdf({ userId, invoiceNumber }) {
    const response = await sessionFetch(buildUrl(`/aleta-billing/invoices/${encodeURIComponent(invoiceNumber)}/download`, { userId }), {
        headers: {
            'x-api-key': API_KEY,
        },
    });

    if (!response.ok) {
        let message = 'No s\'ha pogut descarregar la factura.';

        try {
            const payload = await response.json();
            message = payload?.message || message;
        } catch (_error) {
            // Ignore invalid JSON bodies on download failures.
        }

        throw new Error(message);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = `${invoiceNumber}.pdf`;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(blobUrl);
}
